import { Chip, colors } from "goi_common";
import { SANGJO_REVIEW_DETAIL_TEXT } from "../../constants/reviewTags";

interface TagButtonChipProps {
  tag: string;
  onClick?: () => void;
  isActived: boolean;
}

export const ReviewTagButtonChip = ({ tag, onClick, isActived }: TagButtonChipProps) => {
  const detail = {
    text: "# " + (SANGJO_REVIEW_DETAIL_TEXT[tag] || "전체보기"),
    color: isActived ? colors.white : colors.gray800,
    backgroundColor: isActived ? colors.gray700 : colors.white,
    borderColor: isActived ? "" : colors.gray300,
  };

  return (
    <Chip
      color={detail.color}
      background={detail.backgroundColor}
      borderColor={detail.borderColor}
      padding="4px 12px"
      text={detail.text}
      onClick={onClick ? onClick : () => {}}
      className="subtitle_14_sb"
    />
  );
};
